import { render, staticRenderFns } from "./BlockHero.vue?vue&type=template&id=5f455e95&scoped=true&"
import script from "./BlockHero.vue?vue&type=script&lang=js&"
export * from "./BlockHero.vue?vue&type=script&lang=js&"
import style0 from "./BlockHero.vue?vue&type=style&index=0&id=5f455e95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f455e95",
  null
  
)

export default component.exports